//import aws from './aws';
import { config } from '../../config/config';
import utils from './utils';

const platformClient = window.require('platformClient');
const apiClient = platformClient.ApiClient.instance

export let accessToken = undefined
export let host = undefined
export let authorized = undefined
export let env = undefined

export const logout = () => {
    accessToken = undefined
    host = undefined
    authorized = undefined
}

export const login = (environment) => {
    env = environment
    //var cfg = config.getPureCloudConfig(environment);
    if (!config.clientId) {
        throw new Error('Environment clientId is not configured.');
    }

    apiClient.setEnvironment(environment);
    accessToken = undefined;

    console.log('Login to: ' + environment);
    console.log('App Environment:', process.env.REACT_APP_CUSTOM_ENV)
    console.log('App redirect url:', config.appUrl)
    console.log('Client Id:', config.clientId)
    return apiClient.loginImplicitGrant(config.clientId, config.appUrl)
        .then(async () => {
            // Logged in
            accessToken = apiClient.authentications['PureCloud OAuth'].accessToken;
            host = config.endpoints.dynatablesBackend;
            console.log('Sucessfully logged in, accessToken: ' + accessToken);
            console.log(apiClient);
            // Check if customer is authorized to use CSV uploader
            // const response = await aws.fetchApplications(accessToken, environment);
            // console.log("response for front end validation")
            // console.log(response);
            // if (response.applications && response.applications.length > 0) {
            //     authorized = !!response.applications.find(x => x.id === 'pureclouddatat1ables');
            //     console.log('authorized:', authorized);
            // }

            console.log('validateOrg, get integration types');
            const integrationsApi = new platformClient.IntegrationsApi();
            const integrationTypes = await utils.getEntities(integrationsApi, 'getIntegrationsTypes');
            console.log('validateOrg, integrationTypes length = ' + integrationTypes.length);

            console.log('validateOrg, find integration type, app name = ' + config.integrationType);
            const integrationType = integrationTypes.find(integrationType => integrationType.id === config.integrationType);
            console.log('validateOrg, integration type = ' + JSON.stringify(integrationType, null, 3));

            if (integrationType) {
                console.log(`Organization is authorized to use Callflow Data Service.`);
                authorized = true;
            } else {
                console.log(`Checking for PS installation`);
                const integrations = await utils.getEntities(integrationsApi, 'getIntegrations')
                let isEntityEnabled = integrations.filter((integType) => integType.integrationType.id === "embedded-client-app" && integType.name === config.appName)[0]

                if (isEntityEnabled) {
                    console.log(`Organization is authorized to use Callflow Data Service.`);
                    authorized = true;
                } else {
                    console.log(`Organization is not authorized to use Callflow Data Service.`);
                    authorized = false;
                }
            }
        })
        .catch(err => {
            // Handle failure response
            console.error(err);
            this.logout;
        });
}

export const isLoggedIn = () => {
    return !!accessToken
}

export const isAuthorized = () => {
    return !!authorized
}

function AuthManager() {

    function sendRestRequest(requestName, method, path, body) {
        if (!accessToken) {
            throw new Error('Authentication required!');
        }
        if (!host) {
            throw new Error('setEnvironment first!');
        }
        if (!requestName) {
            throw new Error('Missing required parameter: requestName');
        }
        if (!method) {
            throw new Error('Missing required parameter: method');
        }
        if (!path) {
            throw new Error('Missing required parameter: path');
        }

        var config = {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'token': accessToken,
                'env': platformClient.ApiClient.instance.environment,
                'tokensource': 'purecloud'
            },
        };

        if (body) {
            config.body = JSON.stringify(body);
        }

        console.log('Begin Request: ' + requestName);
        return new Promise((resolve, reject) => {
            var request = fetch(host + path, config);
            request.then(response => {
                if (response.ok) {
                    console.log('End Request: ' + requestName);
                    response.json().then(data => {
                        resolve(data);
                    }, error => {
                        reject(error);
                    }).catch(error => {
                        reject(error);
                    });
                }
                else {
                    console.error('Request: ' + requestName + ': HTTP ' + response.status + ' (' + response.statusText + ')');
                    console.log('End Request: ' + requestName);
                    reject(new Error('Request: ' + requestName + ': HTTP ' + response.status + ' (' + response.statusText + ')'));
                }
            }, error => {
                reject(error);
            }).catch(error => {
                reject(error);
            });

        });
    }

    this.getFiles = function () {
        var apipath = '/files';

        return sendRestRequest('getFiles', 'GET', apipath, undefined);
    };

    this.uploadFile = function (fileName, type) {
        var apipath = '/file';
        var body = {};

        if (fileName) {
            body.fileName = fileName;
        }

        if (type) {
            body['content-type'] = type;
        }

        return sendRestRequest('uploadFile', 'POST', apipath, body);
    };

    this.deleteFile = function (fileName) {
        var apipath = '/file';
        var body = {};

        if (fileName) {
            body.fileName = fileName;
        }

        return sendRestRequest('deleteFile', 'DELETE', apipath, body);
    };
};

const _AuthManager = new AuthManager();

export default _AuthManager;